import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
const styles = {
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
  },
};

function ContractHTML(props) {
  const { classes } = props;
  return (
    <div className={classes.termsText}>
      <h4>MCSnet Subscriber Contract - Version 2.3</h4>
      <p>
        This is a contract between you, the Subscriber, and LEMALU Holdings ltd.
        doing business as MCSnet (“MCSnet”).
      </p>
      <h4>I. Definitions</h4>
      <p>
        “MCSnet” shall mean LEMALU Holdings Ltd., LEMALU Holdings Ltd. operating
        as MCSnet and its subsidiaries, shareholders, officers, directors,
        employees, agents, contractors, suppliers, providers, successor
        companies and assigns.
      </p>
      <p>
        “Subscriber” shall mean the customer whose name shall appear on the
        signature page and their heirs, agents, employees and invitees who make
        any use whatsoever of the service or services provided by MCSnet at any
        time now or during the course of this contract and any renewals thereof.
      </p>
      <p>
        “Equipment” shall mean any and all buried or overhead fiber optic
        transmission cables and/or any radio equipment installed by MCSnet.
      </p>
      <p>
        “Pre-authorized payment” or “PAP” shall mean a payment, automatically or
        manually processed, either through a Subscriber's credit card or bank
        account.
      </p>
      <p>
        “pre-authorized debit” or “PAD” shall mean a PAP payment processed via
        the Subscriber's bank account.
      </p>
      <h4>II. Service</h4>
      <h4>1. Installation</h4>
      <p>
        The Subscriber agrees to installation fees, minimum monthly package
        level and other requirements as described on the signature form or
        electronic signature form.
      </p>
      <h4> 2. Contract Term</h4>
      <p>
        The Subscriber agrees that this contract is valid in effect for the term
        specified on the signature page plus the remainder of the current month
        and this contract will renew automatically thereafter on a monthly
        basis. The Subscriber agrees that the Subscriber's verbal, email, online
        or written instructions are sufficient to renew, alter or extend the
        term of this contract or enter into a new contract for service(s). If
        multiple services are being installed, a contract shall be in effect for
        each service and each service shall be considered an independent
        agreement with independent terms even if they are billed collectively.
      </p>
      <h4>3. Service Packages</h4>
      <p>
        The Subscriber agrees that the Subscriber's verbal, email, online or
        written instructions are sufficient to upgrade, downgrade, modify or
        otherwise alter services and associated billing. Changes to packages and
        plans can be made at any time but will only take effect at the time of
        the call and will not be retroactive. Subscribers may not downgrade if
        (i) current monthly usage exceeds the cap of the package the subscriber
        wishes to downgrade to; or (ii) the subscriber's package has been
        upgraded within the past 30 days; or (iii) the Subscriber doesn't have
        PAP setup and wishes to change to a package which requires
        pre-authorized payment. MCSnet reserves the right to restrict
        Subscribers from making changes to their account if they have a balance
        which is past due or where payment(s) has(ve) been dishonoured. For
        broadband services (high-speed Internet), the Subscriber further agrees
        that service packages may have usage limits which, if exceeded, may
        result in the Internet connection being interrupted. The Subscriber
        agrees to pay the regular monthly fee associated with the Subscriber's
        chosen service package even if the Subscriber's account is suspended due
        to overuse or non-payment.
      </p>
      <h4>4. Statements and use of email</h4>
      <p>
        The Subscriber understands that MCSnet will deliver monthly statements
        electronically via the MCSnet's website. The Subscriber is responsible
        for the timely payment of these statements and that these electronic
        statements constitute advance notice for automated credit card or EFT
        transactions.
      </p>
      <h4>5. Terms of service </h4>
      <p>
        Services provided by MCSnet are governed by the “MCSnet terms of
        service” which is available online at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.mcsnet.ca"
        >
          https://www.mcsnet.ca
        </a>{" "}
        By signing and accepting this contract, the Subscriber acknowledges
        having read, understood and agreed to the conditions and terms therein.
        The Subscriber understands that violation of the “MCSnet terms of
        service” may be grounds for MCSnet to terminate the Subscriber's
        connection. MCSnet may from time to time alter the terms of service by
        posting a new copy on its website at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.mcsnet.ca"
        >
          https://www.mcsnet.ca
        </a>{" "}
        and that any new revisions to the terms of service will be effective 30
        days after they are posted to the MCSnet website.
      </p>
      <h4>6. Payment of Fees</h4>
      <p>
        The Subscriber understands that MCSnet will bill in advance for MCSnet
        services. All contracts require automated monthly payments by PAP except
        Subscribers who are (i) on the “Extreme” level packages or greater AND
        (ii) are on a month-to-month term. Subscriber agrees and authorizes
        MCSnet to interrupt, suspend or disconnect service(s), including
        Internet service(s), telephone service(s), email service(s), web hosting
        service(s) and any other services provided by MCSnet and any services
        reliant upon the aforementioned services, if the Subscriber's account
        becomes past due or required PAP authorization or information is not
        provided. In the event that the Subscriber fails to fulfill the
        obligations as outlined in this contract, the Subscriber agrees to pay
        MCSnet all collection fees, and legal fees(on a solicitor and own client
        basis) on charges owing, without regard to further legal action taken by
        MCSnet to recover other or related consequential damages suffered as a
        result of the Subscriber's actions.
      </p>
      <h4> 7. Termination</h4>
      <p>
        Termination of a service before expiration of the term will result in
        the Subscriber paying to MCSnet a termination fee which shall be
        calculated by dividing the contract discount by the number of months in
        the term and multiplying by the number of months remaining in the term.
        The contract term begins on the first day of the month following
        activation of the service and the number of months remaining shall be
        rounded up to the next whole number. Relocation of broadband services to
        a new structure or building requires termination of the existing
        contract (and payment of deactivation and termination fees) and
        re-signing a new term for the new Equipment location at the prevailing
        rates. The parties agree that this is a genuine pre-estimate of the
        damages suffered by MCSnet and is not to be deemed a penalty. Upon
        cancellation, credits shall be issued for any pre-billed amounts, the
        aforementioned fees shall be charged, and the balance owing will be
        collected in accordance with paragraph 6 above. If a credit balance
        exceeding $10.00 remains on account, MCSnet shall return this amount to
        the Subscriber within 90 days either by cheque or electronic payment at
        MCSnet's discretion. Credit balances of less than $10.00 shall be
        forfeited. MCSnet reserves the right to terminate this contract at any
        time. If MCSnet chooses to terminate this agreement, an early
        termination or disconnection fee will NOT be charged unless this
        agreement is being terminated because the Subscriber violated this
        agreement or the “MCSnet terms of service”.
      </p>
      <h4>8. Warranty Disclaimer and Limitation of Liability</h4>
      <p>
        The Subscriber does hereby request that MCSnet install and maintain any
        and all Equipment and or software required in order to receive services
        from MCSnet. In allowing MCSnet to enter the Subscriber's premises, or
        by the signing of this contract, the Subscriber does hereby release
        MCSnet of the following: Any claims, liabilities, losses and damages
        arising directly or indirectly from the installation activities of
        MCSnet, and all subsequent use of any and all services or Equipment
        provided by MCSnet including damage to hardware, software files or data.
        MCSnet does not guarantee uninterrupted services operation. MCSnet and
        its directors, officers, agents, assigns, underlying carriers, licensors
        and suppliers provide the services “as is” and make no express or
        implied warranties of any kind regarding the services, facilities,
        network, Equipment or products in any way. To the extent applicable by
        law, MCSnet and its directors, officers, agents, assigns, underlying
        carriers, licensors and suppliers make no warranty of merchantability or
        fitness for a particular purpose or use. In particular and without
        limitation, MCSnet and its directors, officers, agents, assigns,
        underlying carriers, licensors and suppliers are not liable for: (i)
        disruption or interruption in Service availability, INCLUDING
        UNAVAILABILITY OF 9-1-1 SERVICE; (ii) any event beyond MCSnet control,
        including acts of God, inclement weather, labour disputes, riots, civil
        disputes, war or armed conflict, any law, governmental order, regulation
        or decision; or (iii) damage to the Equipment on your premises.
        Notwithstanding the foregoing, MCSnet and its directors, officers,
        agents, assigns, underlying carriers, licensors and suppliers, shall in
        no event be liable to you or any person for any actual, direct,
        indirect, consequential, special, incidental, reliance, punitive or any
        other damages, or lost profits of any kind whatsoever, injury, death or
        damage to person or property, whether in negligence, breach of contract,
        tort or other causes of action, arising out of the provision of services
        or in any way from this agreement, INCLUDING BUT NOT LIMITED TO THE
        AVAILABILITY OF 9-1-1 SERVICES. In the event MCSnet is found liable by a
        court of competent jurisdiction, liability will not exceed an amount
        equal to the price of services purchased by you during the month
        preceding the event in question. THE SUBSCRIBER AGREES THAT THE
        LIMITATIONS OF LIABILITY SET OUT IN THIS AGREEMENT ARE FAIR AND
        REASONABLE IN THE COMMERCIAL CIRCUMSTANCES OF THIS AGREEMENT AND THAT
        MCSnet WOULD NOT HAVE ENTERED INTO THIS AGREEMENT BUT FOR THE
        SUBSCRIBER'S AGREEMENT TO LIMIT MCSNET'S LIABILITY IN THE MANNER AND TO
        THE EXTENT PROVIDED FOR IN THIS AGREEMENT.
      </p>
      <h4>9. Broadband - Service Availability</h4>
      <p>
        The Subscriber understands that this contract does not constitute an
        offer from MCSnet to provide the Broadband (or high speed Internet)
        services. Due to the nature of high frequency radio devices that may be
        employed in the delivery of the service, the availability of this
        service can only be determined at setup time by MCSnet installers and
        the availability of the service is subject to change at some time after
        installation has been completed. If MCSnet installers are unable to
        obtain an acceptable signal at time of installation, no fees will be
        charged. In MCSnet fiber communities, if a fiber supplying the
        subscriber premise fails, MCSnet may, at its option, substitute a
        wireless service to enable subscriber connectivity for up to 6 months.
        If MCSnet deems that your location is no longer serviceable some time
        after installation, MCSnet will waive any applicable termination or
        cancellation fees. If the Subscriber's location is deemed as no longer
        serviceable within the first 12 months of the contract term, MCSnet will
        also refund a portion of the installation fees paid, corresponding to
        the number of months remaining in the first year. Such refunds shall not
        include any hardware purchases and installation fees paid shall be net
        of any credits offered against them by MCSnet at time of installation.
        MCSnet will not, under any circumstances be liable for any other
        expenses associated with unavailability of broadband service to the
        Subscriber.
      </p>
      <h4>10. Broadband - Equipment</h4>
      <p>
        All radio Equipment and/or fiber optic Equipment will at all times
        remain the property of MCSnet, unless provided otherwise. The Subscriber
        agrees not to sell, transfer, lease, assign any interest in or mortgage
        or encumber all or any part of the Equipment provided by MCSnet. The
        Subscriber agrees to pay MCSnet the full cost of repair and or
        replacement of any lost, stolen, unreturned, damaged, sold, encumbered
        or assigned Equipment plus any labor cost. All Equipment will hereby
        remain on site, at the address listed, for the sole use of MCSnet
        Internet service. The Subscriber provides a $500.00 guarantee for the
        assigned Equipment rental and the Subscriber agrees that the guarantee
        amount will be charged in the event the radio Equipment is lost, stolen,
        unreturned, damaged, sold, encumbered or assigned. The Subscriber
        authorizes MCSnet to enter the Subscribers property during the hours of
        7:00 AM to 9:00 PM on Monday through Saturday, without further notice,
        to install, upgrade, service, troubleshoot or remove outdoor mounted
        Equipment.
      </p>
      <h4> 11. Telephone - Emergency Services – 911 Dialing</h4>
      <p>
        The Subscriber understands that MCSnet offers a form of 911 service that
        is similar to traditional 911 service but has some important differences
        and limitations when compared with enhanced 911 service (E911) available
        in most locations in conjunction with traditional telephone services. It
        is the sole responsibility of the Subscriber to regularly update 911
        location information to ensure that it is kept up to date. The
        Subscriber further understands and acknowledges that 911 dialing is
        likely to be inoperable in the event of a phone, broadband or power
        outage or if phone and/or Internet has been suspended for any reason
        whatsoever. The Subscriber agrees to purchase, subscribe to and
        maintain, in operable condition, an alternate means to contact Emergency
        Services/911 that is not reliant upon MCSnet services or the electrical
        power grid and to make others aware of its location and use.
      </p>
      <h4>12. Telephone - Local Number Portability</h4>
      <p>
        In certain locales, MCSnet may offer the ability to transfer a phone
        number that the Subscriber currently subscribes to using another
        telecommunications provider to MCSnet. The transfer process may result
        in interruption to one or both of your telephone services while the
        number is being transferred.
      </p>
      <h4>13. Telephone - Directory Listings</h4>
      <p>
        The Subscriber agrees that phone number may not be listed in the phone
        directory. Phone numbers transferred from another telecommunications
        provider may, however, be listed (but are in no way guaranteed to be
        listed). In the future, MCSnet may, at its discretion, provide the
        option of listing your phone number in certain telephone directories,
        but this feature, if offered, is in no way guaranteed.{" "}
      </p>
      <h4>14. Telephone - Limitations</h4>
      <p>
        The Subscriber further agrees that, although MCSnet VoIP services may be
        marketed as “unlimited”, MCSnet reserves the right to suspend or
        terminate services if utilization exceeds 3000 minutes per calendar
        month. In addition, the Subscriber agrees that MCSnet may, at its
        discretion, and without notice, suspend or terminate your account if
        MCSnet deems, at its sole discretion, that usage or usage pattern is or
        was atypical. 0+ Operator Assisted Calling, calls to 900 numbers, calls
        to certain 8xx numbers, calls to x11 (excluding 911), calls to
        information numbers, collect calls and certain International
        destinations are not supported using MCSnet VoIP.
      </p>
      <h4> 15. Telephone – Incompatibility</h4>
      <p>
        The Subscriber acknowledges that MCSnet telephone services are designed
        to support human voice conversations over ordinary telephones ONLY and
        that the use of other devices such as (but not limited to) fax machines,
        modems, debit machines or security/fire/burglar/medical alarms are
        unsupported. These devices may not function reliably and should not be
        installed. In addition, MCSnet's VoIP service may be incompatible with
        some broadband connections or routers. MCSnet assumes no obligation to
        provide support for any third party products or services.
      </p>
      <h4>16. Taxes </h4>
      <p>
        The Subscriber understands that prices indicated in this contract
        exclude applicable government taxes and charges. MCSnet will charge all
        applicable sales taxes and goods and services taxes to services or fees.
        MCSnet reserves the right to pass along to the Subscriber, in addition
        to monthly fees and taxes above, the costs and administrative expenses
        associated with government/municipal taxes, tariffs or fees levied on
        Internet Service Providers or tower owners/occupants.
      </p>
      <h4> 17. Contact</h4>
      <p>
        The Subscriber consents to MCSnet contacting the Subscriber during or
        after the term of the contract or subsequent renewals thereof via
        lettermail, email, telephone, fax or any other communication method
        which may be provided by the Subscriber before, during or after the term
        of the contract or subsequent renewals thereof. It is the Subscriber's
        sole responsibility to ensure MCSnet has current contact information,
        including an email address, where the Subscriber can be reached by
        MCSnet in event of emergency or payment issues.
      </p>
      <h4>18. Resale</h4>
      <p>
        The Subscriber shall not resell MCSnet services in any way, including,
        but not limited to, reselling the connection, reselling disk space,
        reselling web services, reselling emails, or hosting web pages for third
        parties except by express written agreement between MCSnet and the
        Subscriber.
      </p>
      <h4>19. Headings</h4>
      <p>
        All headings of the Sections of this Agreement have been inserted for
        convenience of reference only, are not to be considered a part of this
        Agreement, and shall in no way affect the interpretation of any of the
        provisions of this Agreement.
      </p>
      <h4>20. Waiver </h4>
      <p>
        MCSnet's failure to insist upon strict compliance with any of the terms,
        covenants, or conditions hereof shall not be deemed a waiver of such
        term, covenant, or condition, nor shall any waiver or relinquishment of
        any right or power hereunder at any one time or more times be deemed a
        waiver or relinquishment of such right or power at any other time or
        times.
      </p>
      <h4>21. Severability</h4>
      <p>
        If any provision of this Agreement shall for any reason and to any
        extent be invalid or unenforceable, the remainder of this Agreement and
        the application of such provision to other persons or circumstances
        shall not be affected thereby, but rather shall be enforced to the
        greatest extent permitted by law.
      </p>
      <h4>22. Assignment</h4>
      <p>
        The Subscriber shall not assign its rights under this Agreement. MCSnet
        may assign any or all of its rights under this agreement and any
        renewals thereof without notice to or approval from the Subscriber.
      </p>
      <h4>23. Enurement</h4>
      <p>
        This Agreement shall enure to the benefit of and be binding upon the
        parties, any Assignee of MCSnet, and their heirs, administrators,
        executors and successors of the parties.
      </p>
      <h4>24. Governing Law and Attornment</h4>
      <p>
        This Agreement is governed by the laws in force in the Province of
        Alberta and the parties irrevocably attorn to the jurisdiction of the
        courts in the Province of Alberta and proceedings taken in respect of
        this agreement shall be taken in these courts and in no other.{" "}
      </p>
      <h4>25. Notices</h4>
      <p>
        Any notices under this Agreement shall be in writing and may be served
        by either party personally to any Director of the other party, posted by
        prepaid letter addressed to the registered office of that other party or
        sent by email to that other party to a number/email address notified by
        that party in writing for the purposes of this Agreement. Notice so
        delivered, posted or sent will be effective when the notice would in
        ordinary course be delivered and as proof of service addressing and
        stamping will suffice. Notice given by fax shall be deemed served upon
        receipt of a clear transmission report. Notice given by email shall be
        deemed served on the working day after the message appears in the
        sender’s “sent items”. MCSnet can be contacted by postal mail at PO Box
        98, 4810-50 Ave, St. Paul, AB T0A 3A0, by telephone at 866-390-3928.
        Subscriber is responsible to provide and update MCSnet with current
        address, telephone and email address.
      </p>
      <h4>26. Entire Agreement</h4>
      <p>
        This agreement constitutes the entire agreement between the parties with
        respect to the subject matter hereof and supersedes all prior
        negotiations, proposals and agreements, whether oral or written, with
        respect to the subject matter hereof. There are between the parties no
        representations, inducements, promises, understandings, conditions or
        warranties, express, implied or statutory, other than as expressly set
        forth in this Agreement.
      </p>
      <h4>III. Pre-authorized Payment</h4>
      <p>
        1. The Subscriber authorizes MCSnet, and the financial institution
        designated (or any other financial institution that the Subscriber may
        authorize at any time) to begin deductions from the Subscriber's bank
        account or credit card for monthly regular recurring payments and/or
        one-time payments from time to time, for payment of all charges arising
        on the Subscriber's MCSnet account(s).
      </p>
      <p>
        2. Regular monthly payments for the full amount of services delivered
        will be debited from Subscriber's specified account or credit card on or
        after the 1st day of each month.
      </p>
      <p>
        3. The Subscriber agrees to waive the requirement for written
        pre-notification as on-line access to our statements or invoices is
        available.
      </p>
      <p>
        4. The type of service for all our pre-authorized debit
        transactions(“PAD”) shall be considered PERSONAL.
      </p>
      <p>
        5. The details of my payment information will be held in electronic file
        and may be changed at any time by the Subscriber either by written,
        electronic or verbal instructions provided to MCSnet.
      </p>
      <p>
        6. This authority is to remain in effect until MCSnet has received
        notification from the Subscriber of its change or termination. This
        notification must be received at least ten (10) business days before the
        next debit is scheduled. The Subscriber may obtain a sample cancellation
        form, or more information on the Subscriber's right to cancel a PAD
        Agreement at any financial institution or by visiting
        http://www.cdnpay.ca
      </p>
      <p>
        7. The Subscriber understands that, although they are permitted to
        cancel the PAD agreement, failure to subsequently provide alternate form
        of PAP will be a breach of this Contract if this Contract requires PAP
        (see paragraph II.6).
      </p>
      <p>
        8. MCSnet may charge a service charge for each monthly PAP that are not
        successful.
      </p>
      <p>
        9. MCSnet may not assign this authorization, whether directly or
        indirectly, by operation of law, change of control or otherwise, without
        providing at least 10 days prior written notice to the Subscriber.
      </p>
      <p>
        10. The Subscriber has certain recourse rights if any debit does not
        comply with this agreement. For example, the right to receive
        reimbursement for any PAD that is not authorized or is not consistent
        with this PAD Agreement. To obtain a form for a Reimbursement Claim, or
        for more information on recourse rights, the Subscriber may contact any
        financial institution or visit www.cdnpay.ca
      </p>
      <h4>IV. Authorization</h4>
      <p>
        By signing the signature form or electronic signature form, you agree to
        installation fees, contract discount and other requirements as described
        on the signature form and this contract and acknowledge that you have
        read and understood all the provisions contained in this contract,
        including in the “pre-authorized payment” section and in the “Terms of
        service”. You warrant that you have authority to enter into this
        contract and that all persons whose signatures are required to sign have
        signed.
      </p>
    </div>
  );
}

export default withStyles(styles)(ContractHTML);
